import { useState } from "react";
import { ROText } from '@/components/locale';

export default function ShareMenu({ title }: { title: string }) {
  const url = window.location.href;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => {setCopied(false); setOpen(!open)}, 1500);
  };

  return (
    <div className="relative flex justify-end">
      <button
        onClick={() => setOpen(!open)}
        className="bg-primary text-white px-3 py-1 rounded-full text-sm"
      >
        🔗 <ROText i18n="share"/>
      </button>

      {open && (
        <div className="absolute mt-6 bg-white shadow-lg rounded-lg p-2 space-y-1 w-40 z-50">
          <button
            onClick={copyLink}
            className="w-full text-left text-black text-sm px-2 py-1 hover:bg-gray-100 rounded"
          >
            {copied ? "✅ Copied!" : "Copy link"}
          </button>

          <a
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-black text-sm px-2 py-1 hover:bg-gray-100 rounded"
          >
            Share on X
          </a>
          {/* <a
            href={`https://wa.me/?text=${encodeURIComponent(title + " " + url)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-black text-sm px-2 py-1 hover:bg-gray-100 rounded"
          >
            💬 Share on WhatsApp
          </a> */}
        </div>
      )}
    </div>
  );
}
